<!--
  --
  -- オプション選択コンポーネント
  --
  -->
<template>
  <div>
    <!-- switch -->
    <template v-if="option.max === 1 && !option.unit">
      <v-switch
        class="mt-0"
        dense hide-details
        v-model="option.quantity"
        :false-value="0"
        :true-value="1"
      />
    </template>

    <!-- select box -->
    <template v-else>
      <v-select
        class="mt-0" style="padding-bottom: 2px;"
        dense hide-details
        v-model="option.quantity"
        :items="quantities"
      >
      </v-select>
    </template>

    <!-- 単価 -->
    <div class="text-body-2 mt-2">
      <span class="text--primary">
        <template v-if="option.unitCharge > 0">
          {{option.unitCharge | comma}} {{chargeTypeText}}
        </template>
        <template v-else>
          無料
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import * as C from '@/consts'

export default {
  name: 'COptionSelect',
  props: {
    option: {
      type: Object,
      required: true
    }
  },

  computed: {
    quantities () {
      const max = this.option.max
      const unit = this.option.unit || ''
      const q = new Array(max + 1)
      for (let n = 0; n <= max; ++n) {
        q[n] = {
          value: n,
          text: (n === 0) ? 'なし' : `${n} ${unit}`
        }
      }
      return q
    },

    chargeTypeText () {
      return this.option.chargeType === C.OPTION_CHARGE_DAY ? '円/日' : '円'
    }
  }
}
</script>
